import { FunctionComponent } from "react";
import {
  PassportBankInfoForm,
  PassportOwnerInfoForm,
  PassportPaymentMethodsForm,
  PassportTnCForm,
  PassportBusinessInfo,
} from "src/modules/forms";

export const PASSPORT_ROUTES = {
  entityType: "/entity-type",
  paymentMethods: "/payment-methods",
  ownerInfo: "/owner-info",
  businessInfo: "/business-info",
  bankDetails: "/bank-details",
  termsConditions: "/terms-and-conditions",
  onboardingCompleted: "/onboarding-completed",
};

type IRoute = {
  label: string;
  path: string;
  Component: FunctionComponent<any>;
};

export const PASSPORT_FORM_ROUTES: IRoute[] = [
  {
    label: "payment_methods",
    path: PASSPORT_ROUTES.paymentMethods,
    Component: PassportPaymentMethodsForm,
  },
  {
    label: "owner_info",
    path: PASSPORT_ROUTES.ownerInfo,
    Component: PassportOwnerInfoForm,
  },
  {
    label: "business_info",
    path: PASSPORT_ROUTES.businessInfo,
    Component: PassportBusinessInfo,
  },
  {
    label: "bank_details",
    path: PASSPORT_ROUTES.bankDetails,
    Component: PassportBankInfoForm,
  },
  {
    label: "terms_and_conditions",
    path: PASSPORT_ROUTES.termsConditions,
    Component: PassportTnCForm,
  },
];
